import {
  SwapBenifitTag,
  SwapBg,
  SwapChart,
  SwapChartFilter,
  SwapChartHeader,
  SwapChartTitle,
  SwapContainer,
  SwapExtension,
  SwapHeader,
  SwapInner,
  SwapTop,
  SwapWrapper,
  SwapWrapperModal,
} from "./styled";
import ChooseToken from "./ChooseToken";
import { useContext, useEffect, useState } from "react";
import SettingSwap from "./Setting";
import { Coins } from "ton3-core";
import { useForm } from "react-hook-form";
import default_token_image from "../../../assets/Dashboard/Common/default-token-image.png";
import ConfirmSwap from "./Confirm";
import change_icon from "../../../assets/Dashboard/Swap/change_icon.png";
import change_icon_light from "../../../assets/Dashboard/Swap/change_icon_light.png";
import SwapChartTable from "./Chart";
import SwapModal from "./Tabs/Modal";
import "./Chart/loading.css";
import History from "./History";
import _, { debounce } from "lodash";
import { TabSelect } from "../Liquidity/styled";
import HistoryList from "./History/List";
import { useSelector } from "react-redux";
import { useAppKitAccount } from "@reown/appkit/react";
import axios from "axios";
import dayjs from "dayjs";
import { ContextProviderWrapper } from "../../../components/Context";
import { fieldNormalizer } from "../../../utils/fieldNormalizer";
import { useUnifiedPairBalances } from "../../../hooks/usePairBalances";
import { instanceV2 } from "../../../services/instanceV2";
import ModalOverlay from "../../../components/Common/ModalOverlay";
import { Loader } from "../../../components/Loader";
import TitleCommon from "../../../components/Common/Title";
import { switchDefaultTokens } from "../../../constant";
import { AVAX_API } from "../../../services/api/indexV2";
import BigNumber from "bignumber.js";

export type SwapAction = "offer" | "ask";

const Swap = ({ chainRouter }: any) => {
  const [isShowHistory, setIsShowHistory] = useState(false);
  const { theme, isMobile } = useContext(ContextProviderWrapper)!;
  const [dataInfo, setDataInfo] = useState<any>([]);
  const [keySelected, setKeySelected] = useState<any>("rubic");
  const [listRoute, setListRoute] = useState<any>([]);
  const [fromAmount, setFromAmount] = useState(0);
  const [toAmount, setToAmount] = useState(0);
  const [slippageTolerance, setSlippageTolerance] = useState(0.5);
  const [openFromModal, setOpenFromModal] = useState(false);
  const [openToModal, setOpenToModal] = useState(false);
  const { listTokens, listAggregators, listChains }: any = useSelector(
    (state: any) => state.pool
  );
  const [simulateState, setSimulateState] = useState<any>({
    swapRate: 0,
    minAskUnits: 0,
    offerUnits: 0,
    askUnits: 0,
    tonFeeUnits: 0,
    priceImpact: 0,
    bestRoute: [],
    ortherRoute: [],
    root: null,
    timestamp: 0,
    pathId: null,
  });

  const [fromAssetKey, setFromAssetKey] = useState(
    switchDefaultTokens(chainRouter)?.fromAddress
  );
  const [toAssetKey, setToAssetKey] = useState(
    switchDefaultTokens(chainRouter)?.toAddress
  );
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const { setValue, control } = useForm({ mode: "onChange" });
  const [fromAsset, setFromAsset] = useState<any>(null);
  const [toAsset, setToAsset] = useState<any>(null);
  const { address } = useAppKitAccount();
  const [isRefreshBalance, setIsRefreshBalance] = useState(false);
  const {
    token0Balance: fromAssetBalance,
    token1Balance: toAssetBalance,
    nativeTokenBalance,
  } = useUnifiedPairBalances({
    token0Address: fromAssetKey,
    token1Address: toAssetKey,
    isLoading: isRefreshBalance,
    address,
    chainRouter,
  });

  const [activeFilter, setActiveFilter] = useState(1);
  const [showDetail, setShowDetail] = useState(false);
  const [timeTarget, setTimeTarget] = useState(0);
  const [switchState, setSwitchState] = useState(false);
  const [valueChanges, setValueChanges] = useState(0);
  const [isPending, setIsPending] = useState<any>(false);
  const [textModalTransaction, setTextModalTransaction] =
    useState("Confirm Swap");
  const [openChart, setOpenChart] = useState(false);
  const [listFavorite, setListFavorite] = useState<any>([]);
  const [activeTab, setActiveTab] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const listExtensions = [
    {
      id: 3,
      icon:
        theme === "dark"
          ? "/assets/images/swap/doc.svg"
          : "/assets/images/swap/doc_light.svg",
      activeIcon:
        theme === "dark"
          ? "/assets/images/swap/doc.svg"
          : "/assets/images/swap/doc_light.svg",
    },
    {
      id: 1,
      icon:
        theme === "dark"
          ? "/assets/images/swap/chart.svg"
          : "/assets/images/swap/chart_light.svg",
      activeIcon: "/assets/images/swap/chart_active.svg",
    },
    {
      id: 2,
      icon:
        theme === "dark"
          ? "/assets/images/swap/settings.svg"
          : "/assets/images/swap/settings_light.svg",
      activeIcon: "/assets/images/swap/settings_active.svg",
    },
  ];

  useEffect(() => {
    if (isPending) {
      setTimeout(() => {
        setIsPending(false);
      }, 4000);
    }
  }, [isPending]);

  useEffect(() => {
    setFromAssetKey(switchDefaultTokens(chainRouter)?.fromAddress);
    setToAssetKey(switchDefaultTokens(chainRouter)?.toAddress);
  }, [chainRouter]);

  useEffect(() => {
    const url = new URL(window.location.toString());
    url.searchParams.set("from", fromAsset?.address || fromAssetKey!);
    url.searchParams.set("to", toAsset?.address || toAssetKey!);
    window.history.pushState({}, "", url);
  }, [fromAssetKey, toAssetKey]);

  const handleSelectRoute = (key: string) => {
    setKeySelected(key);
    const bestRoute = listRoute.find((item: any) => item && item.key === key);
    const toAmountNano: any = Coins.fromNano(
      bestRoute?.data?.destAmount,
      toAsset?.decimals
    );
    setToAmount(Number(toAmountNano));
    setSimulateState({
      swapRate: bestRoute?.data?.destAmount,
      minAskUnits: bestRoute?.data?.destAmount,
      offerUnits: fromAmount,
      askUnits: bestRoute?.data?.destAmount,
      tonFeeUnits: Number(bestRoute?.data?.gasUsd),
      priceImpact: 0,
      bestRoute: bestRoute?.data,
      ortherRoute: _.orderBy(listRoute, "data.destUSD", "desc"),
      root: null,
      timestamp: dayjs().unix(),
      pathId: keySelected === "odos" ? bestRoute?.data.pathId : null,
      slippage: slippageTolerance,
      routeAdd: bestRoute?.data?.routerAddress,
    });
  };

  // Count decimal
  const countDecimals = (value: any) => {
    const valueAsString = String(value);
    const splitValue = valueAsString.split(".");
    return splitValue.length > 1 ? splitValue[1].length : 0;
  };

  const handleSendValue = (e: any) => {
    const decimalsCount = countDecimals(e.target.value);
    fieldNormalizer(
      "fromAmount",
      e.target.value || "0",
      setValue,
      fromAsset?.decimals
    );
    if (fromAsset && decimalsCount <= fromAsset?.decimals) {
      debouncedUpdateFromAmount(parseFloat(e.target.value) || 0);
    }
  };

  const handleReceiveValue = (e: any) => {
    const decimalsCount = countDecimals(e.target.value);
    fieldNormalizer(
      "toAmount",
      e.target.value || "0",
      setValue,
      toAsset?.decimals
    );
    if (toAsset && decimalsCount <= toAsset?.decimals) {
      debouncedUpdateToAmount(parseFloat(e.target.value) || 0);
    }
  };

  const handleGetToken = async (
    tokenAddress: string,
    targetKey: "from" | "to"
  ) => {
    try {
      const chain = listChains?.find((item: any) => item.name === chainRouter);
      const params = {
        network: chain?.chainId,
        skip: 0,
        limit: 1,
        symbolOrAddress: tokenAddress,
      };
      if (chain?.chainId) {
        const { data } = await AVAX_API.listToken(params);
        const token = data?.tokens?.[0];
        if (token) {
          if (targetKey === "from") {
            setFromAsset(token);
          } else {
            setToAsset(token);
          }
        }
      }
    } catch (error) {
      console.error(`handleGetListToken (${targetKey}) error:`, error);
    }
  };

  useEffect(() => {
    if (!toAssetKey || !listChains || toAsset) return;
    handleGetToken(toAssetKey, "to");
  }, [listChains, chainRouter]);

  useEffect(() => {
    if (!fromAssetKey || !listChains || fromAsset) return;
    handleGetToken(fromAssetKey, "from");
  }, [listChains, chainRouter]);

  useEffect(() => {
    const defaults = switchDefaultTokens(chainRouter);
    if (defaults) {
      setFromAssetKey(defaults.fromAddress);
      setToAssetKey(defaults.toAddress);
      setFromAsset(null);
      setToAsset(null);
      setFromAmount(0);
      setToAmount(0);
      setListRoute([]);
    }
  }, [chainRouter]);

  const buildResultObject = async (Objpromise: any) => {
    try {
      const { key, promise } = await Objpromise;
      const { data } = await promise;
      return { status: true, data, key };
    } catch (error) {
      return { status: false };
    }
  };

  const handleGetDataRoute = async () => {
    try {
      const amount: any = BigNumber(fromAmount).toFixed();
      if (amount <= 0 || (amount > 0 && listRoute.length > 0)) {
        return;
      }
      const chain = listChains?.find(
        (item: any) => item.name === chainRouter
      )?.chainId;
      const params: any = {
        srcToken: fromAsset?.address,
        destToken: toAsset?.address,
        amount,
        chainId: chain,
      };
      setIsLoading(true);

      const dataRoute = await Promise.all(
        listAggregators
          .map(async (route: any) => {
            return {
              promise: instanceV2.get(route.api_path, { params }),
              key: route.id,
            };
          })
          .map(buildResultObject)
      ).then((results) =>
        results.filter(
          (response) =>
            response?.status &&
            response?.data?.destAmount &&
            response?.data?.destAmount !== "NaN" &&
            response?.data?.destAmount !== "0" &&
            !isNaN(Number(response?.data?.destAmount))
        )
      );
      setListRoute(dataRoute);

      const rubicIndex = dataRoute.findIndex(
        (item: any) => item.key === "rubic"
      );

      const bestRoute =
        rubicIndex !== -1 ? dataRoute[rubicIndex] : dataRoute[0];

      if (!bestRoute) return;

      const toAmountNano: any = Coins.fromNano(
        bestRoute.data.destAmount,
        bestRoute.data.destDecimals
      );

      setToAmount(Number(toAmountNano));
      setKeySelected(bestRoute.key);

      setSimulateState({
        swapRate: bestRoute.data.destAmount,
        minAskUnits: bestRoute.data.destAmount,
        offerUnits: fromAmount,
        askUnits: bestRoute.data.destAmount,
        tonFeeUnits: Number(bestRoute.data.gasUsd),
        priceImpact: 0,
        bestRoute: bestRoute.data,
        ortherRoute: _.orderBy(dataRoute, "data.gasUsd", "asc"),
        root: null,
        timestamp: dayjs().unix(),
        pathId: bestRoute.key === "odos" ? bestRoute.data.pathId : null,
        slippage: slippageTolerance,
        routeAdd: bestRoute.data.routerAddress,
      });

      setIsLoading(false);
    } catch (error) {
      console.log("handleGetDataRoute err", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let intervalGetDataRoute: any = null;
    if (
      listAggregators &&
      listAggregators.length > 0 &&
      fromAsset &&
      toAsset &&
      listRoute &&
      listRoute.length < 1
    ) {
      handleGetDataRoute();
      intervalGetDataRoute = setInterval(() => {
        handleGetDataRoute();
      }, 30000);
    }
    return () => {
      clearInterval(intervalGetDataRoute);
    };
  }, [listAggregators, fromAmount, fromAsset, chainRouter]);

  //   const realPrice = simulateState.swapRate > 0 ? 1 / simulateState.swapRate : 0;

  // const safeMinAskUnits =
  //   simulateState &&
  //   toAsset?.decimals != null &&
  //   !isNaN(Number(simulateState.minAskUnits))
  //     ? Number(Coins.fromNano(simulateState.minAskUnits, toAsset.decimals))
  //     : 0;

  // const safeOfferUnits =
  //   simulateState &&
  //   fromAsset?.decimals != null &&
  //   !isNaN(Number(simulateState.offerUnits))
  //     ? Number(Coins.fromNano(simulateState.offerUnits, fromAsset.decimals))
  //     : 0;
  // const rate = safeOfferUnits > 0 ? safeMinAskUnits / safeOfferUnits : 0;

  const minReceived = toAsset
    ? Coins.fromNano(simulateState.minAskUnits, toAsset?.decimals)
    : new Coins(0);

  const updateFromAmount = (amount: number) => {
    setToAmount(0);
    setFromAmount(amount);
    setListRoute([]);
  };

  const updateToAmount = (amount: number) => {
    setToAmount(amount);
  };

  const debouncedUpdateToAmount = debounce(updateToAmount, 1000);

  const debouncedUpdateFromAmount = debounce(updateFromAmount, 1000);

  useEffect(() => {
    setValue(
      "toAmount",
      new Coins(toAmount, { decimals: toAsset?.decimals }).toString()
    );
  }, [toAmount]);

  useEffect(() => {
    setValue(
      "fromAmount",
      new Coins(fromAmount, { decimals: fromAsset?.decimals }).toString()
    );
  }, [fromAmount]);

  const swapFromTo = () => {
    setFromAssetKey(toAssetKey);
    setToAssetKey(fromAssetKey);
    setFromAsset(toAsset);
    setToAsset(fromAsset);
    setListRoute([]);
    handleGetDataRoute();
    setFromAmount(toAmount);
    setToAmount(fromAmount);
  };

  useEffect(() => {
    if (simulateState.priceImpact > 30 && !showDetail) {
      setShowDetail(true);
    }
  }, [simulateState.priceImpact]);

  useEffect(() => {
    if (!openConfirmModal) {
      setTextModalTransaction("Confirm Swap");
      setFromAmount(0);
      setToAmount(0);
      setSimulateState({
        swapRate: 0,
        minAskUnits: 0,
        offerUnits: 0,
        askUnits: 0,
        tonFeeUnits: 0,
        priceImpact: 0,
        bestRoute: [],
        ortherRoute: [],
        root: null,
        timestamp: 0,
      });
    }
    if (openConfirmModal) {
      setIsRefreshBalance(false);
    }
  }, [openConfirmModal]);

  const handleResetValueFrom = (e: any) => {
    let { value } = e.target;
    if (value === 0 || value === "0") {
      fieldNormalizer("fromAmount", "", setValue, fromAsset?.decimals);
      debouncedUpdateFromAmount(parseFloat(e.target.value));
    }
  };

  const handleResetValueTo = (e: any) => {
    let { value } = e.target;
    if (value === 0 || value === "0") {
      fieldNormalizer("toAmount", "", setValue, fromAsset?.decimals);
      debouncedUpdateFromAmount(parseFloat(e.target.value));
    }
  };

  const handleSwitchTabs = () => {
    switch (activeFilter) {
      case 1:
        return (
          <SwapModal
            fromAssetKey={fromAssetKey}
            fromAssetBalance={fromAssetBalance}
            listTokens={listTokens}
            fromAsset={fromAsset}
            debouncedUpdateFromAmount={debouncedUpdateFromAmount}
            fromAmount={fromAmount}
            setOpenFromModal={setOpenFromModal}
            control={control}
            handleSendValue={handleSendValue}
            swapFromTo={swapFromTo}
            toAssetKey={toAssetKey}
            toAssetBalance={toAssetBalance}
            toAsset={toAsset}
            debouncedUpdateToAmount={debouncedUpdateToAmount}
            toAmount={toAmount}
            setOpenToModal={setOpenToModal}
            handleReceiveValue={handleReceiveValue}
            simulateState={simulateState}
            setOpenConfirmModal={setOpenConfirmModal}
            realPrice={0}
            slippageTolerance={slippageTolerance}
            minReceived={minReceived}
            setShowDetail={setShowDetail}
            showDetail={showDetail}
            handleResetValueFrom={handleResetValueFrom}
            handleResetValueTo={handleResetValueTo}
            onSelectRoute={handleSelectRoute}
            keySelected={keySelected}
            loadingRouter={isLoading}
            chainRouter={chainRouter}
            nativeTokenBalance={nativeTokenBalance}
          />
        );
      case 2:
        return (
          <SettingSwap
            slippageTolerance={slippageTolerance}
            setSlippageTolerance={setSlippageTolerance}
            setActiveFilter={setActiveFilter}
            setSwitchState={setSwitchState}
            switchState={switchState}
          />
        );
      default:
        return (
          <SwapModal
            fromAssetKey={fromAssetKey}
            fromAssetBalance={fromAssetBalance}
            listTokens={listTokens}
            fromAsset={fromAsset}
            debouncedUpdateFromAmount={debouncedUpdateFromAmount}
            fromAmount={fromAmount}
            setOpenFromModal={setOpenFromModal}
            control={control}
            handleSendValue={handleSendValue}
            swapFromTo={swapFromTo}
            toAssetKey={toAssetKey}
            toAssetBalance={toAssetBalance}
            toAsset={toAsset}
            debouncedUpdateToAmount={debouncedUpdateToAmount}
            toAmount={toAmount}
            setOpenToModal={setOpenToModal}
            handleReceiveValue={handleReceiveValue}
            simulateState={simulateState}
            setOpenConfirmModal={setOpenConfirmModal}
            realPrice={0}
            slippageTolerance={slippageTolerance}
            minReceived={minReceived}
            setShowDetail={setShowDetail}
            showDetail={showDetail}
            handleResetValueFrom={handleResetValueFrom}
            handleResetValueTo={handleResetValueTo}
            checkingToken={true}
            onSelectRoute={handleSelectRoute}
            keySelected={keySelected}
            loadingRouter={isLoading}
            chainRouter={chainRouter}
            nativeTokenBalance={nativeTokenBalance}
          />
        );
    }
  };

  const handleSwitchTabsMobile = () => {
    switch (activeTab) {
      case 1:
        return (
          <>
            {
              <SwapWrapperModal>
                {!fromAsset || !toAsset ? (
                  <>
                    <SwapWrapper className={theme}>
                      {!isMobile && (
                        <SwapHeader>
                          <TitleCommon text={"SWAP"} />
                        </SwapHeader>
                      )}
                      <Loader />
                    </SwapWrapper>
                  </>
                ) : (
                  <SwapWrapper className={theme}>
                    <SwapModal
                      fromAssetKey={fromAssetKey}
                      fromAssetBalance={fromAssetBalance}
                      fromAsset={fromAsset}
                      debouncedUpdateFromAmount={debouncedUpdateFromAmount}
                      fromAmount={fromAmount}
                      setOpenFromModal={setOpenFromModal}
                      control={control}
                      handleSendValue={handleSendValue}
                      swapFromTo={swapFromTo}
                      toAssetKey={toAssetKey}
                      toAssetBalance={toAssetBalance}
                      toAsset={toAsset}
                      debouncedUpdateToAmount={debouncedUpdateToAmount}
                      toAmount={toAmount}
                      setOpenToModal={setOpenToModal}
                      handleReceiveValue={handleReceiveValue}
                      simulateState={simulateState}
                      setOpenConfirmModal={setOpenConfirmModal}
                      realPrice={0}
                      slippageTolerance={slippageTolerance}
                      minReceived={minReceived}
                      setShowDetail={setShowDetail}
                      showDetail={showDetail}
                      handleResetValueFrom={handleResetValueFrom}
                      handleResetValueTo={handleResetValueTo}
                      checkingToken={true}
                      onSelectRoute={handleSelectRoute}
                      keySelected={keySelected}
                      loadingRouter={isLoading}
                      chainRouter={chainRouter}
                      nativeTokenBalance={nativeTokenBalance}
                    />
                  </SwapWrapper>
                )}
              </SwapWrapperModal>
            }
          </>
        );
      case 3:
        return (
          <SwapWrapperModal>
            <SwapWrapper className={theme}>
              <SettingSwap
                slippageTolerance={slippageTolerance}
                setSlippageTolerance={setSlippageTolerance}
                setActiveFilter={setActiveFilter}
                setSwitchState={setSwitchState}
                switchState={switchState}
                setActiveTab={setActiveTab}
              />
            </SwapWrapper>
          </SwapWrapperModal>
        );
      case 4:
        return (
          <SwapWrapperModal>
            <SwapWrapper
              style={{
                height: "calc(100vh - 450px)",
                overflowY: "auto",
              }}
              className={theme}
            >
              <HistoryList />
            </SwapWrapper>
          </SwapWrapperModal>
        );
      default:
        return (
          <>
            {openChart && (
              <SwapWrapperModal>
                {!fromAsset || !toAsset ? (
                  <>
                    <SwapWrapper className={theme}>
                      {!isMobile && (
                        <SwapHeader>
                          <TitleCommon text={"SWAP"} />
                        </SwapHeader>
                      )}
                      <Loader />
                    </SwapWrapper>
                  </>
                ) : (
                  <SwapWrapper className={theme}>
                    <SwapModal
                      fromAssetKey={fromAssetKey}
                      fromAssetBalance={fromAssetBalance}
                      fromAsset={fromAsset}
                      debouncedUpdateFromAmount={debouncedUpdateFromAmount}
                      fromAmount={fromAmount}
                      setOpenFromModal={setOpenFromModal}
                      control={control}
                      handleSendValue={handleSendValue}
                      swapFromTo={swapFromTo}
                      toAssetKey={toAssetKey}
                      toAssetBalance={toAssetBalance}
                      toAsset={toAsset}
                      debouncedUpdateToAmount={debouncedUpdateToAmount}
                      toAmount={toAmount}
                      setOpenToModal={setOpenToModal}
                      handleReceiveValue={handleReceiveValue}
                      simulateState={simulateState}
                      setOpenConfirmModal={setOpenConfirmModal}
                      realPrice={0}
                      slippageTolerance={slippageTolerance}
                      minReceived={minReceived}
                      setShowDetail={setShowDetail}
                      showDetail={showDetail}
                      handleResetValueFrom={handleResetValueFrom}
                      handleResetValueTo={handleResetValueTo}
                      loadingRouter={isLoading}
                      chainRouter={chainRouter}
                      nativeTokenBalance={nativeTokenBalance}
                    />
                  </SwapWrapper>
                )}
              </SwapWrapperModal>
            )}
          </>
        );
    }
  };

  const handleGetData = async () => {
    try {
      const res = await axios.get(
        "https://aggregator.kibble.exchange/api/statistics"
      );
      if (res) {
        setDataInfo(res?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleGetData();
  }, []);

  const TradableTokens = dataInfo
    ? dataInfo?.find(
        (item: any) => item.id === "1a8ec5d3-d743-48a6-8400-06d9e4c76686"
      )?.value
    : "--";
  const WeeklyVolume = dataInfo
    ? dataInfo?.find(
        (item: any) => item.id === "d0dfcb1f-eb01-4ad5-9891-e09b5ee198ba"
      )?.value
    : "--";
  const LastWeekTxs = dataInfo
    ? dataInfo?.find(
        (item: any) => item.id === "d1a86f9c-6daa-4918-a192-07c1e0c31a80"
      )?.value
    : "--";
  const LastWeekWebTraffic = dataInfo
    ? dataInfo?.find(
        (item: any) => item.id === "8d241a73-3a1e-4905-b724-8de5f4eea16c"
      )?.value
    : "--";
  const MonthlyActiveWallet = dataInfo
    ? dataInfo?.find(
        (item: any) => item.id === "73934bb3-75d4-4487-889f-c77eb9cd1f33"
      )?.value
    : "--";
  const MonthlyUserGrowthRate = dataInfo
    ? dataInfo?.find(
        (item: any) => item.id === "d386123a-28a2-4fba-b0cb-25add8255a22"
      )?.value
    : "--";

  return (
    <SwapBg>
      {isShowHistory && <History onClose={setIsShowHistory} />}
      <SwapContainer>
        <SwapTop>
          <TitleCommon text={"Kibble Swap"} />
          <SwapBenifitTag className={theme}>
            <div>
              <h3>Tradable Tokens</h3>
              <p>{TradableTokens}</p>
            </div>
            <div>
              <h3>Weekly volume</h3>
              <p>${WeeklyVolume}</p>
            </div>
            <div>
              <h3>Last Week Transactions</h3>
              <p>{LastWeekTxs}</p>
            </div>
            <div>
              <h3>Last Week's Traffic</h3>
              <p>{LastWeekWebTraffic}</p>
            </div>
            <div>
              <h3>Monthly Active Wallet</h3>
              <p>{MonthlyActiveWallet}</p>
            </div>
            <div>
              <h3>Monthly user growth</h3>
              <p>{MonthlyUserGrowthRate}</p>
            </div>
            <br />
          </SwapBenifitTag>
        </SwapTop>
        {isMobile && (
          <>
            <TabSelect className={theme} active={activeTab}>
              <button
                onClick={() => {
                  setActiveTab(1);
                  setOpenChart(true);
                }}
              >
                Swap
              </button>
              <button
                onClick={() => {
                  setActiveTab(2);
                  setOpenChart(false);
                }}
              >
                Statistics
              </button>
              <button
                onClick={() => {
                  setActiveTab(3);
                  setOpenChart(true);
                }}
              >
                Settings
              </button>
              <button
                onClick={() => {
                  setActiveTab(4);
                  setOpenChart(true);
                }}
              >
                History
              </button>
            </TabSelect>
          </>
        )}
        <SwapInner className={openChart ? `active` : ``}>
          <SwapChart
            className={
              openChart && !isMobile
                ? `active ${theme}`
                : isMobile && activeTab !== 2
                ? `active ${theme}`
                : `${theme}`
            }
          >
            <SwapChartHeader>
              <SwapChartTitle className={theme} isDown={valueChanges < 0}>
                <img
                  style={{ cursor: "pointer" }}
                  onClick={async () => {
                    swapFromTo();
                  }}
                  src={theme === "light" ? change_icon_light : change_icon}
                  alt="icon"
                />
                <div>
                  <figure>
                    <img
                      src={
                        fromAsset?.img ? fromAsset?.img : default_token_image
                      }
                      alt="icon"
                      onError={(e) =>
                        (e.currentTarget.src = default_token_image)
                      }
                    />
                  </figure>
                  <figure>
                    <img
                      src={toAsset?.img ? toAsset?.img : default_token_image}
                      alt="icon"
                      onError={(e) =>
                        (e.currentTarget.src = default_token_image)
                      }
                    />
                  </figure>
                </div>
                <div>
                  <p>{fromAsset?.symbol ? fromAsset?.symbol : "??"} / </p>
                  <p>{toAsset?.symbol ? toAsset?.symbol : "??"}</p>
                  <span>
                    {valueChanges > 0 ? "+" : ""}
                    {valueChanges?.toFixed(2)}%
                  </span>
                </div>
              </SwapChartTitle>
              <SwapChartFilter className={theme} ispending={isPending}>
                {chartFilter.map((item, index) => {
                  return (
                    <li
                      onClick={() => {
                        if (!isPending) {
                          setTimeTarget(index);
                          setIsPending(true);
                        }
                      }}
                      className={timeTarget === index ? "active" : ""}
                      key={index}
                    >
                      {item.text}
                    </li>
                  );
                })}
              </SwapChartFilter>
            </SwapChartHeader>
            {/* Chart */}
            <SwapChartTable
              setValueChanges={setValueChanges}
              valueChanges={valueChanges}
              fromAssetKey={fromAssetKey}
              toAssetKey={toAssetKey}
              chainRouter={chainRouter}
            />
          </SwapChart>
          {isMobile && handleSwitchTabsMobile()}
          {!isMobile && (
            <SwapWrapperModal
              style={{
                height:
                  activeFilter === 1 || activeFilter === 2 || activeFilter === 3
                    ? "auto"
                    : "405px",
              }}
            >
              {!fromAsset || !toAsset ? (
                <>
                  <SwapWrapper className={theme}>
                    <SwapHeader>
                      <TitleCommon text={"SWAP"} />
                    </SwapHeader>
                    <Loader />
                  </SwapWrapper>
                </>
              ) : (
                <>
                  <SwapWrapper className={theme}>
                    <SwapHeader>
                      <TitleCommon
                        text={activeFilter === 1 ? "SWAP" : "SWAP SETTINGS"}
                      />
                      <SwapExtension className={theme}>
                        {listExtensions.map((item, index) => {
                          return (
                            <li
                              onClick={() => {
                                if (item.id !== 3) {
                                  setActiveFilter(item.id);
                                }
                                if (item.id === 1) {
                                  setOpenChart(!openChart);
                                }
                                if (item.id === 3) {
                                  setIsShowHistory(true);
                                }
                              }}
                              key={index}
                            >
                              <img
                                src={
                                  activeFilter === item.id
                                    ? item.icon
                                    : item.activeIcon
                                }
                                alt="icon"
                              />
                            </li>
                          );
                        })}
                      </SwapExtension>
                    </SwapHeader>
                    {!isMobile && handleSwitchTabs()}
                  </SwapWrapper>
                </>
              )}
            </SwapWrapperModal>
          )}
        </SwapInner>
      </SwapContainer>
      <ModalOverlay
        component={
          <ChooseToken
            isFromModal={openFromModal}
            otherCurrentAssetKey={fromAssetKey!}
            otherToAssetKey={toAssetKey}
            setCurrentAsset={setFromAssetKey}
            setOtherCurrentAsset={setToAssetKey}
            setOpenFromModal={setOpenFromModal}
            // set Amount
            setAmountFrom={setFromAmount}
            setAmountTo={setToAmount}
            // favorite
            setListFavorite={setListFavorite}
            listFavorite={listFavorite}
            //Checking token
            isModal={1}
            // Chain based on router
            chainRouter={chainRouter}
            catchAsset={setFromAsset}
          />
        }
        open={openFromModal}
        setOpen={setOpenFromModal}
        title={"Select a token"}
        width="430px"
      />
      <ModalOverlay
        component={
          <ChooseToken
            isFromModal={openToModal}
            otherCurrentAssetKey={toAssetKey!}
            otherToAssetKey={fromAssetKey}
            setCurrentAsset={setToAssetKey}
            setOpenFromModal={setOpenToModal}
            // set Amount
            setAmountFrom={setFromAmount}
            setAmountTo={setToAmount}
            // favorite
            setListFavorite={setListFavorite}
            listFavorite={listFavorite}
            isModal={2}
            // Chain based on router
            chainRouter={chainRouter}
            catchAsset={setToAsset}
          />
        }
        open={openToModal}
        setOpen={setOpenToModal}
        title={"Select a token"}
        width="430px"
      />
      <ModalOverlay
        component={
          <ConfirmSwap
            fromAsset={fromAsset}
            toAsset={toAsset}
            fromAmount={fromAmount}
            toAmount={toAmount}
            minReceived={minReceived}
            slippageTolerance={slippageTolerance}
            setOpenConfirmModal={setOpenConfirmModal}
            openConfirmModal={openConfirmModal}
            simulateState={simulateState}
            realPrice={0}
            setFromAmount={setFromAmount}
            setToAmount={setToAmount}
            setTextModalTransaction={setTextModalTransaction}
            updateFromAmount={updateFromAmount}
            updateToAmount={updateToAmount}
            onRefresh={() => {
              setIsRefreshBalance(true);
            }}
            keyRoute={keySelected}
            chainRouter={chainRouter}
          />
        }
        open={openConfirmModal}
        setOpen={setOpenConfirmModal}
        title={textModalTransaction}
        width="500px"
      />
    </SwapBg>
  );
};

const chartFilter = [
  {
    id: 1,
    value: 86400000,
    text: "24H",
  },
];

export default Swap;
